module.exports = __webpack_public_path__ + "static/img/fayuan-icon4.f7abd4f4.png";